import React from 'react';
import AddressForm from '../Forms/AddressForm';
import Loading from '../Loading/Loading';
import Button from '../Button';

export default function AddressEditModal(props) {
	const {
		handleAddressUpdateInput,
		patchAddress,
		setNewAddressFormOpen,
		setShowEdit,
		updatedAddress,
		updateLoading,
		setUpdateLoading,
	} = props || {};

	return (
		<div className='mainModal'>
			<AddressForm address={updatedAddress} handleAddressInput={handleAddressUpdateInput} required={true} />
			{!updateLoading ? (
				<div className='btnCont modal reverse'>
					<Button
						text='Update address'
						style='primary'
						type='lg'
						onClick={() => {
							patchAddress(updatedAddress);
							setUpdateLoading(true);
						}}
					/>
					<Button
						text='Cancel'
						style='secondary'
						type='lg'
						onClick={() => {
							setNewAddressFormOpen(false);
							setShowEdit(false);
						}}
					/>
				</div>
			) : (
				<>
					<Loading type='circle' size='small' />
				</>
			)}
		</div>
	);
}
